/**
*
*   Customer API
*       - A Layer for Customer data Hooked between Storefront + Shopify Tools
*
**/

//
import Config from '@/config';
import Storefront from '@/libraries/shopify/class';
import ShopifyTools from '@/libraries/shopify-tools/class';
import ShopifyServerTools from '@/libraries/shopify-tools/server';
import CustomerAPI from '@/libraries/shopify-customer/class';
//import { signOut } from 'next-auth/react';
import { redirect } from 'next/navigation';
import moment from 'moment-timezone';

/**
*
*   Customer Class
*
*
**/

//Customer Object
const Customer = {

	//The Customer data
	_data: {},


	/**
	*
	*   Loads Customer Data
	*
	*
	**/
	data: async ({ accessToken , authType }) => {

		//New Customer API
		if( authType == 'customer' ) return ( await CustomerAPI( accessToken ).get() )?.body;

		//Standard Storefront
		return ( await Storefront.Customer.get( accessToken ) )?.body;

	},


	/**
	*
	*   Load a Customer
	*       - Loads the Current Customer based on the session access token
	*
	*   Params:
	*       session:        (Object) The Session with accessToken
	*
	**/
	load: async ({ accessToken , authType }) => {

		//Get the Token
		const token = accessToken;

		//Ensure it only loads once
		if( Customer._data[ token ] ) return Customer._data[ token ];

		//Get the Customer Details
		const customer = await Customer.data({ accessToken , authType });

		//Return session expired
		if( ( !customer && typeof window !== 'undefined' ) )
			window.location.redirect = '/api/auth/signout';

		//Server Side Redirect on session expired
		if( !customer ) redirect('/api/auth/signout' );

		//Is the customer [...]
		customer.is = {

			//Is the Customer a Wholesale Client
			wholesale: ( found => {
				Config.wholesale.tags.every( tag => {
					if( customer.tags.indexOf( tag.trim() ) > -1 )
						found = true;
					return !found;
				});
				return found;
			})(false),

			//Is the customer an admin
			admin: customer.tags.indexOf('Admin') > -1

		};

		//Load the Rewards
		const rewards = await (async ()=>{

			//Frontend
			if( typeof window !== 'undefined' ) return await ShopifyTools.Rewards.get();

			//Initialize
			const ServerTools = await ShopifyServerTools();

			//Return Server
			return {
				result: 1,
				body:   await ServerTools.Rewards.get( ShopifyTools.id( customer.id ) )
			};

		})();

		//Add it
		Customer._data[ token ] = {
			...customer,

			//Merge Rewards
			rewards: {
				...rewards?.body,
				base: ( rewards?.body?.points || 0 )
			},

			//Customer Birthday
			birthday: ( rewards => {

				//Assign the birthday
				const birthday = moment( rewards.birthday ).year(
					moment().format('YYYY')
				);

				return {

					//Has the customer received a gift this year
					gifted: !rewards?.gifted || ( new Date() ).getFullYear() > rewards.gifted.getFullYear(),

					//Has the birthday happened in the last 1 month
					inLastMonth: rewards?.birthday && (
						moment().isSameOrAfter( birthday ) &&
						moment().isBefore( moment( birthday ).add( 1 , 'month' ) )
					),

					//Is the customer birthday today
					today: rewards?.birthday && (
						moment().isSame( birthday )
					)

				};

			})( rewards?.body )
		};

		//The Customer Object
		return Customer._data[ token ];

	}

};


//Output
export default Customer;